// @flow
/* eslint-disable ta-code-conventions/has-matching-storydoc,ta-code-conventions/has-matching-test */

import * as React from 'react';
import useAuthGated from '@ta/login.auth-gate-original';
import useAuthGatedLithium from '@ta/login.auth-gate-lithium';
import { featureIsEnabled } from '@ta/common.features';
import { Login } from '@ta/login.login';

/**
 * A temporary solution to use 2 different implementations of login gate in Lithium and non-Lithium environments.
 * It would be removed id WP-2663.
 */
const LoginProvider = (props: { children: React.Node }) => {
  const login = useAuthGated();
  const lithiumLogin = useAuthGatedLithium();

  const loginCallback = featureIsEnabled('apr_lithium_control') ? lithiumLogin : login;
  return <Login.Provider value={loginCallback}>{props.children}</Login.Provider>;
};

export default LoginProvider;
